import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// ヒーロースライダー
export default class extends Controller {
  connect() {
    this.handleResize();
    // 検証ツール等で表示幅がPC/SPをまたいで変わった場合に、表示側のスライダーを初期化し直す
    this.resizeListener = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.handleResize(), 200);
    };
    window.addEventListener("resize", this.resizeListener);
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeListener);
    clearTimeout(this.resizeTimer);
    this.destroySwiper();
  }

  handleResize() {
    const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const suffix = w < 768 ? "sp" : "pc";

    // 既に表示中の側で初期化済みなら何もしない（同一幅帯での微小リサイズで再生成しない）
    if (this.currentSuffix === suffix && this.swiper) return;

    this.destroySwiper();
    this.currentSuffix = suffix;
    this.initializeSwiper(suffix);
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = undefined;
    }
  }

  initializeSwiper(suffix) {
    const el = this.element.querySelector(`.js-top-hero-slider-${suffix}`);
    if (!el) return;

    // 1枚のみの場合はloopを無効化し、中央に静止表示する（コントロールはswiper-button-lockで自動的に隠れる）。
    const slideCount = el.querySelectorAll(".swiper-slide").length;

    this.swiper = new Swiper(el, {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: slideCount > 1,
      spaceBetween: 16,
      speed: 400,
      slidesPerView: "auto",
      centeredSlides: true,
      breakpoints: {
        768: {
          spaceBetween: 32,
        },
      },
      pagination: {
        el: el.querySelector(".js-top-hero-slider-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".js-top-hero-slider-next"),
        prevEl: el.querySelector(".js-top-hero-slider-prev"),
      },
      keyboard: {
        enabled: true,
      },
    });
  }

  sliderstop(e) {
    if (!this.swiper) return;

    if ($(e.currentTarget).hasClass("is-pause")) {
      this.swiper.autoplay.start();
      $(e.currentTarget).removeClass("is-pause");
      $(e.currentTarget).text("停止する");
    } else {
      this.swiper.autoplay.stop();
      $(e.currentTarget).addClass("is-pause");
      $(e.currentTarget).text("再生する");
    }
  }
}
